
import React from 'react';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import AppSidebar from '@/components/layout/AppSidebar';
import Header from '@/components/layout/Header';
import DashboardOverview from '@/components/dashboard/DashboardOverview';

// L'auto-launch del tour welcome e' gestito globalmente da TourBootstrap (F18 v2),
// che legge profiles.completed_tours dal DB e parte solo per utenti untouched.
// Il vecchio hook useOnboardingTour (v1, solo localStorage) e' stato rimosso
// perche' causava re-trigger ad ogni dashboard quando il localStorage era vuoto
// (cambio browser, incognito, o utente nuovo) anche se il DB diceva completato.

const Dashboard = () => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <SidebarInset className="flex flex-col">
          <Header />
          <main className="flex-1 p-6 md:p-8">
            <DashboardOverview />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default Dashboard;
